import { useMutation, useQueryClient } from "@tanstack/react-query";
import { finalize } from "@services/subscriberSyncUpload";

export function useFinalizeSubscriberSync(options: any = {}) {
  const queryClient = useQueryClient();

  return useMutation(finalize, {
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({ queryKey: ["subscriberSyncUploads"] });
      queryClient.invalidateQueries({
        queryKey: ["subscriberSyncUpload", variables.uploadId],
      });
    },
    ...options,
  });
}
